import { render, staticRenderFns } from "./VxTabs.vue?vue&type=template&id=79a0be26&scoped=true&lang=html"
import script from "./VxTabs.vue?vue&type=script&lang=js"
export * from "./VxTabs.vue?vue&type=script&lang=js"
import style0 from "./VxTabs.vue?vue&type=style&index=0&id=79a0be26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a0be26",
  null
  
)

export default component.exports